import { Prop, Vue, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import type { CreateElement } from 'vue';
import openAdStyle from './open-show-style.vue';
import AddSiteAd from '@/views/components/newDisplayConfig/addNewSiteAd';
import { RenovationColor, RenovationColorList } from '@/views/components/styleConfig';
import ShopDisplayOpenAd from '@/views/components/shopDisplaySketchMap/shopDisplayOpenAd';
import { IPSService } from '@/services/ipsServices';
import { noop, QinggerLibUtils } from '@/util';
import { AD_TEXT, AdStateText, linkTypeSelect } from '@/views/components/shopDisplayTable/shopDisplayTable';
import baseAPIService from '@/services/base/baseAPIService';

const isset = QinggerLibUtils.isset;


@Component({
  components: { 'shop-display-open-ad': ShopDisplayOpenAd },
  mixins: [openAdStyle],
})
export default class OpenShow extends Vue {
  @Prop({ default: RenovationColor.redOrangeWhite })
  themeCode: number;

  @Prop({ default: 2 })
  mode: number;

  @Prop({ default: () => [] })
  classList: ItemArray;

  @Prop()
  siteId: number;

  @Prop()
  coupon: number;

  @Prop()
  siteCodes: string[];

  @Prop({default: 0})
  sgId: number;

  theme = '';

  @Watch('themeCode', { immediate: true })
  onThemeCodeChange(n, o) {
    if (n && n !== 0) {
      this.theme = RenovationColorList[n];
    }
  }

  dataList = null;

  loading = false;

  // sgId = 0;
  page = 1;
  public corpId = baseAPIService.resolveCorpId();
  pageSize = 10;
  total = 0;
  keyword = '';
  addAdDialog = false;
  ygswpId = 0;

  mounted() {
    this.getData();
  }

  getData() {
    IPSService.adminOpenAdvList({
      postParams: {
        siteId: this.siteId,
        corpId: this.corpId,
        page: this.page,
        keyword: this.keyword,
        pageNum: 10,

      },
    }).then((res) => {
      this.total = res.count;
      this.dataList = res?.list;
    });
  }


  handleEditAd(row) {
    this.handleAddAd(row);
  }

  handleDeleteAd(id) {
    this.$confirm('确认删除？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      IPSService.adminOpenAdvDelete({ postParams: { siteId: this.siteId, ygswpIds: [id] } }).then((res) => {
        if (res.result) {
          this.$message.success('删除成功！');
          this.getData();
        }
      });
    });
  }

  handleAddAd(row = null) {
    let params = {
      sgId: this.sgId,
      siteId: this.siteId,
      corpId: this.corpId,
      coupon: this.coupon,
      title: row?.ygswpId ? '编辑广告' : '新增广告',
      classList: this.classList,
      siteCodes: this.siteCodes,
      adName: row?.advName||''
    };
    if (row?.ygswpId) {
      // @ts-expect-error
      params = { ...params, id: row.ygswpId };
    }
    AddSiteAd.open({ ...params }).then((res) => {
      if (res) {
        this.getData();
      }
    });
  }

  /**
   * 切换页码
   * @param {number} val
   */
  onPageChange(val: number): void {
    this.page = val;
    this.getData();
  }

  /**
   * 切换每页显示数量
   * @param {number} val
   */
  onPageSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getData();
  }

  render(h: CreateElement) {
    return (
      <div class="body overflow-hidden">
        <div class="wid-198 full-height r-pa-16 scroll" style="border-right: 1px solid #eee;">
          <shop-display-open-ad sgId={this.sgId} siteId={this.siteId} />
        </div>
        <section class="config">
          {this.renderFilter(h)}
          {this.renderAd(h)}
          {this.renderBottomButton(h)}
        </section>
      </div>
    );
  }

  /**
   * 操作栏按钮
   * @param h
   * @param row
   */
  renderTableBtn(h, row) {
    return (
      <p>
          <span class="scopeSpan text-blue-15" onClick={this.handleEditAd.bind(this, row)}>
            编辑
          </span>
        <span class="scopeSpan text-red" onClick={this.handleDeleteAd.bind(this, row.ygswpId)}>
          删除
        </span>
      </p>
    );
  }

  renderFilter(h: CreateElement) {
    return (
      <div class="filterController r-pr-12">
        <div class="inputWrapper full-width">
          <el-input v-model={this.keyword} placeholder="输入广告名称检索" onEnter={this.getData.bind(this)} />
          <i class="iconfont iconsousuo" onClick={this.getData.bind(this)} />
        </div>
      </div>
    );
  }

  renderAd(h) {
    return (
      <div class=" overflow-auto" style="height:100%">
        <el-table ref="pTable" class="el-table" data={this.dataList} v-loading={this.loading}
                  height="100%"
                  element-loading-text="加载中"
        >
          <el-table-column prop="advName" label="广告名称" />
          <el-table-column
            prop="statusName"
            label="有效期"
            align="left"
            width="400"
          />
          <el-table-column
            prop="status"
            label="状态"
            align="center"
            width="80"
            {...{
              scopedSlots: {
                default: (scope) => {
                  return scope.row.status == 2 ? '未开始' : scope.row.status == 1 ? '有效' : '失效';
                },
              },
            }}
          />
          <el-table-column prop="empName" label="更新人" align="center" />
          <el-table-column
            prop="updateTime"
            label="更新时间"
            width="180"
          />
          <el-table-column
            align="center"
            label="操作"
            width="150"
            fixed="right"
            {...{
              scopedSlots: {
                default: (scope) => {
                  return this.renderTableBtn(h, scope.row);
                },
              },
            }}
          />
        </el-table>
      </div>
    );
  }

  renderBottomButton(h: CreateElement) {
    return (
      <div class="bottomWrapper">
        <el-button type="primary" onClick={() => this.handleAddAd()}>
          新增
        </el-button>
        <el-pagination
          on-size-change={this.onPageSizeChange}
          on-current-change={this.onPageChange}
          current-page={this.page}
          page-sizes={[10, 30, 60, 100]}
          pager-count={5}
          page-size={this.pageSize}
          layout="total, sizes, prev, pager, next, jumper"
          total={this.total}
        />

      </div>
    );
  }

}
